import React from "react";
import { Box, Grid } from "@mui/material";
// import CashAdvanceService from "../../../services/CashAdvanceService";
// import { useSelector } from "react-redux";
import DelendCentralizedCircularProgress from "../../../components/CircularProgress/DelendCentralizedCircularProgress";
import FeesInformation from "./components/FeesInformation";
import SignCreditRequestModal from "./components/SignCreditRequestModal";
import AnticipationProposal from "./components/AnticipationProposal";
import ReceiptorBankAccount from "./components/ReceiptorBankAccount";
import ContractConfirmation from "./components/ContractConfirmation";
import CreditSimulationHeader from "./components/CreditSimulationHeader";
import RejectedState from "./components/RejectedState";
import { useSelector } from "react-redux";
import CashAdvanceService from "../../../services/CashAdvanceService";

const CreditSimulation = () => {
  const [open, setOpen] = React.useState(true);
  const [openSignCreditRequestModal, setOpenSignCreditRequestModal] =
    React.useState(false);

  const [simulation, setSimulation] = React.useState({
    receivables: [],
    errors: "",
  });

  const receivables = useSelector((state) => state.receivable);

  const fetchReceivable = async () => {
    const response = await CashAdvanceService.simulation(receivables);

    if (response.status !== 200) {
      return setSimulation({ ...simulation, errors: response.message });
    }

    if (response?.data) {
      setSimulation({ ...simulation, receivables: response.data });
    }
  };

  React.useEffect(() => {
    fetchReceivable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (simulation.receivables?.length === 0 && simulation.errors === "") {
    return <DelendCentralizedCircularProgress />;
  }

  if (simulation.errors !== "") {
    return <RejectedState />;
  }

  return (
    <Box>
      <CreditSimulationHeader />
      <Grid container padding={"24px 0px"} spacing={2} columnSpacing={0}>
        <Grid item xs={12} md={8}>
          <AnticipationProposal
            setOpen={setOpen}
            open={open}
            data={simulation.receivables}
          />

          {simulation.receivables.contractTerms && (
            <FeesInformation
              contractTerms={simulation.receivables.contractTerms}
            />
          )}

          <ReceiptorBankAccount
            bankAccount={simulation.receivables.bankAccount}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          {simulation.receivables.contractTerms !== undefined && (
            <ContractConfirmation
              openSignModal={setOpenSignCreditRequestModal}
            />
          )}
        </Grid>
      </Grid>

      <SignCreditRequestModal
        receivable={simulation.receivables}
        opened={openSignCreditRequestModal}
        closeCallback={setOpenSignCreditRequestModal}
      />
    </Box>
  );
};

export default CreditSimulation;
